import { useI18n } from 'vue-i18n';
import pageFooterMsgEn from 'src/i18n/en-us/layouts/pageFooter.json';
import pageFooterMsgId from 'src/i18n/id/layouts/pageFooter.json';
import pageFooterMsgZh from 'src/i18n/zh/layouts/pageFooter.json';
const pageFooterIntPlugin = () => {
    const { t } = useI18n({
        useScope: 'local',
        locale: 'en-US',
        fallbackLocale: 'en-US',
        messages: {
            'en-US': pageFooterMsgEn,
            'id': pageFooterMsgId,
            'zh': pageFooterMsgZh
        }
    });
    return { t };
};
export { pageFooterIntPlugin };
